var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"c-auth-page__head"},[_c('h1',[_vm._v(_vm._s(_vm.$t('h1')))]),_c('h2',[_vm._v(_vm._s(_vm.$t('h2')))])]),_c('form-enter-password'),_c('router-link',{staticClass:"link-btn forgot-password",attrs:{"to":{"name":"enter-forgot-code"}}},[_vm._v(_vm._s(_vm.$t('forgot-password')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }